<script>
import {onBeforeUnmount, onMounted, ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swal from "sweetalert2";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name:'ChatsProfile',
  components: {NavbarPage, LoadingPage},
  setup(){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    var loading = ref(false)

    let profile_id = useRoute().params.id
    let profile_type = ref(useRoute().params.type)

    var chats = ref([])



    function load_chats() {
      loading.value = true

      let data = {
        action: 'show_chats_profile',
        profile_type: profile_type.value,
        profile_id: profile_id,
      }

      FreeWorld.Heisenberg(data , 'user_chat' , true).then((result)=>{

        loading.value = false
        let res = result.data
        chats.value = res

      }).catch((result)=>{

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_chats()
            }
          })

        } else {

          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_chats()
            }
          })

        }
      })
    }
    load_chats()


    const update_orders = ref(null)
    onMounted(()=>{
      update_orders.value = setInterval(() => {
        let data = {
          action: 'show_chats_profile',
          profile_type: profile_type.value,
          profile_id: profile_id,
        }

        FreeWorld.Heisenberg(data , 'user_chat' , true).then((result)=>{

          loading.value = false
          chats.value = result.data

        }).catch(() => {
          console.log('RefreshPage = error')
        })
      }, 3000)
    })
    onBeforeUnmount(()=>{
      clearInterval(update_orders.value)
    })

    return{
      loading,
      chats,
      profile_type,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          چت های من
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="chats.length == 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/no-message.png" alt="">
        <br>
        <p class="font-4 ">
          ... پروفایل شما درحال حاضر چت فعالی ندارد
        </p>
      </div>
    </div>

    <div v-else class="p-body mt-2 animate__animated animate__fadeIn">

      <router-link v-for="item in chats" :key=item.user_id :to="{name:'UserChat', params:{'user_id':item.user_id , 'type':profile_type , 'send':profile_type , 'prof_id':item.profile_id , 'name':item.name}}" class="animate__animated animate__fadeIn text-decoration-none">
        <div class="p-3 rounded-4 bg-white mb-2">
          <div class="d-flex justify-content-between align-items-center position-relative">
            <p class="font-5 px-4 m-0">
              <span>{{ item.time }}</span>
              &nbsp;
              <span>{{ item.date }}</span>
            </p>
            <p class="font-4 font-bold m-0">{{ item.name }}</p>
            <div v-if="item.massageShow == 1 " class="read_chat bg-danger"></div>
          </div>
          <hr>
          <div dir="rtl" class="w-100">
            <p class="text_chat_user m-0 w-75 font-5">{{ item.last_chat }}</p>
          </div>
        </div>
      </router-link>

    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>
    <div class="rounded-4 bg-white font-bold font-color p-3 mb-4 w-75 ma-auto">چت های من</div>

    <div style="height: 70vh" class="bg-white p-4 overflow-y-scroll rounded-4 w-75 m-auto">
      <div v-if="chats.length === 0 " class="p-body w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/no-message.png" alt="">
          <br>
          <p class="font-4 ">
            ... پروفایل شما درحال حاضر چت فعالی ندارد
          </p>
        </div>
      </div>

      <div v-else class="animate__animated animate__fadeIn">
        <router-link v-for="item in chats" :key=item.user_id :to="{name:'UserChat', params:{'user_id':item.user_id , 'type':profile_type , 'send':profile_type , 'prof_id':item.profile_id , 'name':item.name}}" class="animate__animated animate__fadeIn text-decoration-none">
          <div class="p-3 rounded-4 bg-white mb-2">
            <div class="d-flex justify-content-between align-items-center position-relative">
              <p class="font-5 px-4 m-0">
                <span>{{ item.time }}</span>
                &nbsp;
                <span>{{ item.date }}</span>
              </p>
              <p class="font-4 font-bold m-0">{{ item.name }}</p>
              <div v-if="item.massageShow == 1 " class="read_chat bg-danger"></div>
            </div>
            <hr>
            <div dir="rtl" class="w-100">
              <p class="text_chat_user m-0 w-75 font-5">{{ item.last_chat }}</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>

</template>

<style scoped>

.read_chat{
  width: 13px;
  height: 13px;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: -5px;
}
.text_chat_user{
  height: 25px;
  white-space: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}

</style>